<div [formGroup]="mainForm">
    <div fxLayout="row wrap" fxLayoutAlign="end center">
      <mat-card-actions class="btn_area_right">
        <button type="submit"
          mat-raised-button
          color="primary"
          class="btn"
          [disabled]="mainForm.invalid"
        >登録</button>
      </mat-card-actions>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="end center">
      <mat-card-actions class="btn_area_right">
        <button type="button"
          mat-raised-button
          color="primary"
          class="btn btnPrev"
          (click)="goToPrevious()"
        >戻る</button>
      </mat-card-actions>
    </div>
  </div>